import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';
import Axios from "axios"

export default function Adduser(props) {
    /*const [items, setitems] = useState({ f_name: "", l_name: "", username: "", password: "", email: "", phone: "", discount: 0, company_id: props.companyid, usertypeid: "" })*/
    const [items, setitems] = useState({ f_name: "", l_name: "", username: "", password: "", repassword: "", company_id: props.companyid, usertypeid: "" })
    const [type, settype] = useState([])
    const [files, setfiles] = useState([])
    const [mainimage, setmainimage] = useState([])
    const [mainimage2, setmainimage2] = useState([])
    const [typevalue, settypevalue] = useState();
    useEffect(() => {
        fetchUsertype();
    }, [])
    async function fetchUsertype() {
        
        var res = await Axios.get(process.env.REACT_APP_APIURL + "Company/GetCompanies")

        var type = [];
        res.data.map((u) => {
            type.push({ value: u.company_id, label: u.name });
        })
        settype(type)
    }
    const MainImageSelectHandler = (e) => {
        setmainimage({ files: e.target.files });
    }
    const MainImage2SelectHandler = (e) => {
        setmainimage2({ files: e.target.files });
    }
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    const refresh = () => {
        settypevalue(null)
        /*setitems({ f_name: "", l_name: "", username: "", password: "", email: "", phone: "", discount: 0, company_id: props.companyid, usertypeid: "" });*/
        setitems({ f_name: "", l_name: "", username: "", password: "", repassword: "", company_id: props.companyid, usertypeid: "" });
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "User/Adduser";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();

            }
        })
    }

    async function uploadMainImage() {
        debugger;
        const formData = new FormData();
        await formData.append("MainimageUrl", mainimage.files[0])
        await formData.append("MainimageUrl2", mainimage2.files[0])
        await formData.append("companyid", typevalue.value);
        await formData.append("fname", items.f_name);
        await formData.append("lname", items.l_name);
        await formData.append("username", items.username);
        await formData.append("pass", items.password);
        await formData.append("repass", items.repassword);

        try {
            const res = await Axios.post(process.env.REACT_APP_APIURL + "booking/uploaduserfile", formData,
                {
                    headers: {
                        'content-type': 'form-data'
                    }
                })
            if (res.status == 201) {
                document.getElementById("fileInputId").value = null;
                document.getElementById("fileInputId1").value = null;
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();
              
                return 1;
            }
            else if (res.status === 200) {
               
                return 2
            }
        }
        catch (ex) {
            console.log(ex)
            return 0;
        }

    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger;
        if (items.usertypeid === "") {
            swal({
                title: "Usertype Required!",
                icon: "error"
            })
            return;
        }
        if (items.repassword === items.password) {

        }
        else {
            swal({
                title: "Password and Confirm Password does not match!",
                icon: "error"
            })
            return;
        }
        let f1 = document.getElementById("fileInputId1").value
        if (f1 === "") {
            swal({
                icon: "error",
                title: "Please select image!"
            })
            return;
        }
        let f2 = document.getElementById("fileInputId2").value
        if (f2 === "") {
            swal({
                icon: "error",
                title: "Please select image!"
            })
            return;
        }
        await uploadMainImage()

        //items.company_id = props.companyid
        //savemethod(items);
    }
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Add User</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row flex-column align-items-center">
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">First Name *</label>
                                        <input type="text" className="form-control" name="f_name" autoComplete="off" value={items.f_name} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Last Name</label>
                                        <input type="text" className="form-control" name="l_name" autoComplete="off" value={items.l_name} onChange={handleInput} />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Username *</label>
                                        <input type="text" className="form-control" name="username" autoComplete="off" value={items.username} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Passoword *</label>
                                        <input type="text" className="form-control" name="password" autoComplete="off" value={items.password} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Confirm Passoword *</label>
                                        <input type="text" className="form-control" name="repassword" autoComplete="off" value={items.repassword} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label>Comapany Name *</label>
                                        <Select options={type} value={typevalue} onChange={(e) => { settypevalue(e); setitems({ ...items, usertypeid: e.value }) }} />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label htmlFor="unit_name" className="form-label">Main Logo*</label>
                                        <input className="form-control" id="fileInputId1" type="file" onChange={MainImageSelectHandler} accept="image/*" />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <img src={items.image1 !== undefined ? 'data:image/png;base64,' + items.image1 : "Assets/images/image-placeholder.jpg"} width="250px" alt='placeholder image' />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label htmlFor="unit_name" className="form-label">Short Logo*</label>
                                        <input className="form-control" id="fileInputId2" type="file" onChange={MainImage2SelectHandler} accept="image/*" />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <img src={items.image2 !== undefined ? 'data:image/png;base64,' + items.image2 : "Assets/images/image-placeholder.jpg"} width="250px" alt='logo image'/>
                                    </div>
                                    {/*<div className="mb-3 col-sm-6 col-lg-6">*/}
                                    {/*    <label className="form-label">Email</label>*/}
                                    {/*    <input type="email" className="form-control" name="email" autoComplete="off" value={items.email} onChange={handleInput}  />*/}
                                    {/*</div>*/}
                                    {/*<div className="mb-3 col-sm-6 col-lg-6">*/}
                                    {/*    <label className="form-label">Phone</label>*/}
                                    {/*    <input type="number" className="form-control" name="phone" autoComplete="off" value={items.phone} onChange={handleInput}  />*/}
                                    {/*</div>*/}
                                    {/*<div className="mb-3 col-sm-6 col-lg-6">*/}
                                    {/*    <label>Discount(%)</label>*/}
                                    {/*    <input type="number" className="form-control" name="discount" autoComplete="off" value={items.discount} onChange={handleInput} />*/}
                                    {/*</div>*/}
                                   
                                </div>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}